if (!customElements.get('content-variant-picker')) {
  class ContentVariantPicker extends HTMLElement {
    connectedCallback() {
      this.buttonAction = this.dataset.buttonAction || 'add_to_cart';
      this.productForm = this.closest('.product')?.querySelector(
        `product-form[data-id="${this.dataset.formId}"]`,
      );

      this.addEventListener('change', this.onChange.bind(this));

      const checked = this.querySelector('input[type="radio"]:checked');
      if (checked) {
        this.syncFromInput(checked);
      }
    }

    onChange(event) {
      if (event.target.matches('input[type="radio"]')) {
        this.syncFromInput(event.target);
      }
    }

    syncFromInput(input) {
      if (this.buttonAction !== 'add_to_cart' || !this.productForm) return;

      const variantIdInput = this.productForm.querySelector('[name="id"]');
      const sellingPlanIdInput = this.productForm.querySelector(
        '[name="selling_plan"]',
      );

      if (!variantIdInput || !sellingPlanIdInput) return;

      const hasSellingPlan = input.hasAttribute('data-selling-plan-id');

      variantIdInput.value = input.dataset.variantId;
      sellingPlanIdInput.value = hasSellingPlan
        ? input.dataset.sellingPlanId
        : '';
      sellingPlanIdInput.disabled = !hasSellingPlan;
    }
  }

  customElements.define('content-variant-picker', ContentVariantPicker);
}
